import React, { Component } from 'react';
import { formView } from '../../Enums';

class StaticContent extends Component {
  render() {
    let gc = this.props.getContent;
    let guc = this.props.getUniversalContent;
    let gs = this.props.getStyle;
    let gi = this.props.getImage;

    return (
      <div>
        <img
          style={{
            objectFit: 'cover',
            position: 'absolute',
            left: '-6px',
            top: '-6px',
            minWidth: '103%',
            height: '103%'
          }}
          src="/partnerpage/images/form_one_blur_image.jpg"
        ></img>

        {this.props.formViewMode == formView.STEP_ONE && (
          <div style={gs('form_one_static_content')}>
            <div style={gs('form_stats_entity_parent')}>
              <img
                style={gs('form_stats_entity_image')}
                src={gi('rooms_form')}
              />

              <span style={gs('form_stats_entity_text_big')}>
                {gc('rooms_form')}
              </span>

              <span style={gs('form_stats_entity_text_small')}>
                {gc('rooms')}
              </span>
            </div>

            <div style={gs('form_stats_entity_parent')}>
              <img
                style={gs('form_stats_entity_image')}
                src={gi('hotel_form')}
              />

              <span style={gs('form_stats_entity_text_big')}>
                {gc('hotel_form')}
              </span>

              <span style={gs('form_stats_entity_text_small')}>
                {gc('hotel_form_sub')}
              </span>
            </div>

            <div style={gs('form_stats_entity_parent')}>
              <img
                style={gs('form_stats_entity_image')}
                src={gi('oyo_guests_form')}
              />

              <span style={gs('form_stats_entity_text_big')}>
                {gc('oyo_guests_form')}
              </span>

              <span style={gs('form_stats_entity_text_small')}>
                {gc('oyo_guests_form_sub')}
              </span>
            </div>

            <div style={gs('form_stats_entity_parent')}>
              <img
                style={gs('form_stats_entity_image')}
                src={gi('countries_form')}
              />

              <span style={gs('form_stats_entity_text_big')}>
                {gc('countries_form')}
              </span>

              <span style={gs('form_stats_entity_text_small')}>
                {gc('countries')}
              </span>
            </div>
          </div>
        )}

        {this.props.formViewMode > formView.STEP_ONE && (
          <div style={{ ...gs('form_one_static_content'), top: '155px' }}>
            <div style={gs('why_join_form')}>
              {gc('form_static_content_heading_2')}
            </div>

            <div
              style={{
                ...gs('form_stats_entity_parent'),
                marginBottom: '30px'
              }}
            >
              <img
                style={gs('form_stats_entity_image')}
                src={gi('rooms_form')}
              />

              <span
                style={{
                  ...gs('form_stats_entity_text_small'),
                  marginLeft: '24px'
                }}
              >
                {gc('form_2_pt1')}
              </span>
            </div>

            <div
              style={{
                ...gs('form_stats_entity_parent'),
                marginBottom: '30px'
              }}
            >
              <img
                style={gs('form_stats_entity_image')}
                src={gi('hotel_form')}
              />

              <span
                style={{
                  ...gs('form_stats_entity_text_small'),
                  marginLeft: '24px'
                }}
              >
                {gc('form_2_pt2')}
              </span>
            </div>

            <div
              style={{
                ...gs('form_stats_entity_parent'),
                marginBottom: '30px'
              }}
            >
              <img
                style={gs('form_stats_entity_image')}
                src={gi('countries_form')}
              />

              <span
                style={{
                  ...gs('form_stats_entity_text_small'),
                  marginLeft: '24px'
                }}
              >
                {gc('form_2_pt3')}
              </span>
            </div>

            <div
              style={{
                ...gs('form_stats_entity_parent'),
                marginBottom: '30px'
              }}
            >
              <img
                style={gs('form_stats_entity_image')}
                src={gi('oyo_guests_form')}
              />

              <span
                style={{
                  ...gs('form_stats_entity_text_small'),
                  marginLeft: '24px'
                }}
              >
                {gc('form_2_pt4')}
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default StaticContent;

//form_static_content_heading_2
//form_2_pt1
//hotel_form_sub
//rooms
//oyo_guests_form_sub
